import ActivitiesPage from '~/pages/ActivitiesPage.vue';
import ActivityDashboardPage from '~/pages/ActivityDashboardPage.vue';
import AdminPage from '~/pages/AdminPage.vue';
import AdminTranscendHackathonPage from '~/pages/AdminTranscendHackathonPage.vue';
import BonusPointsPage from '~/pages/BonusPointsPage.vue';
import DashboardPage from '~/pages/DashboardPage.vue';
import DocumentationPage from '~/pages/DocumentationPage.vue';
import HackathonEventsPage from '~/pages/HackathonEventsPage.vue';
import HackathonPage from '~/pages/HackathonPage.vue';
import HomePage from '~/pages/HomePage.vue';
import InsightsPage from '~/pages/InsightsPage.vue';
import IssueFinderDashboardPage from '~/pages/IssueFinderDashboardPage.vue';
import IssuesPage from '~/pages/IssuesPage.vue';
import LabelathonPage from '~/pages/LabelathonPage.vue';
import LeaderboardPage from '~/pages/LeaderboardPage.vue';
import ManageIssuePage from '~/pages/ManageIssuePage.vue';
import ManageMergeRequestPage from '~/pages/ManageMergeRequestPage.vue';
import NotableContributorsPage from '~/pages/NotableContributorsPage.vue';
import OrganizationPage from '~/pages/OrganizationPage.vue';
import OrganizationsPage from '~/pages/OrganizationsPage.vue';
import RewardsPage from '~/pages/RewardsPage.vue';
import TeamMemberPage from '~/pages/TeamMemberPage.vue';
import TopAnnualContributorsPage from '~/pages/TopAnnualContributorsPage.vue';
import TranscendHackathonPage from '~/pages/TranscendHackathonPage.vue';
import UserEditPage from '~/pages/UserEditPage.vue';
import UserPage from '~/pages/UserPage.vue';

const ORGANIZATION_FOOTER = {
  customText: 'This list is generated using the organizations contributors display publicly in their GitLab profile.',
  learnMoreHref: '/docs/platform-data#recognizing-organizations-that-contribute',
};

export default [
  {
    name: 'dashboard',
    path: '/dashboard',
    component: DashboardPage,
    meta: { title: 'Dashboard' },
  },
  {
    name: 'notable-contributors',
    path: '/notable-contributors',
    component: NotableContributorsPage,
    meta: { title: 'Notable Contributors' },
  },
  {
    name: 'documentation',
    path: '/docs/:page(.*)',
    component: DocumentationPage,
    props: route => ({ page: route.params.page || 'getting-started' }),
    meta: {
      title: 'Documentation',
    },
  },
  {
    name: 'hackathon',
    path: '/hackathon',
    component: HackathonPage,
    meta: { title: 'Hackathon' },
  },
  {
    name: 'hackathon-events',
    path: '/hackathon-events',
    component: HackathonEventsPage,
    meta: { title: 'Hackathons' },
  },
  {
    name: 'transcend-hackathon',
    path: '/transcend-hackathon',
    component: TranscendHackathonPage,
    meta: { title: 'Transcend Hackathon' },
  },
  {
    name: 'admin',
    path: '/admin',
    component: AdminPage,
    meta: { requireAdmin: true, title: 'Admin' },
  },
  {
    name: 'admin-transcend-hackathon',
    path: '/admin/transcend-hackathon',
    component: AdminTranscendHackathonPage,
    meta: { requireAdmin: true, title: 'Transcend Hackathon admin' },
  },
  {
    name: 'insights',
    path: '/insights',
    component: InsightsPage,
    meta: {
      requireLogin: true,
      title: 'Insights',
    },
  },
  { name: 'labelathon',
    path: '/labelathon',
    component: LabelathonPage,
    meta: { title: 'Labelathon' },
  },
  {
    name: 'home',
    path: '/',
    component: HomePage,
  },
  { name: 'issues',
    path: '/issues',
    component: IssuesPage,
    meta: { title: 'Issue finder' },
  },
  {
    name: 'leaderboard',
    path: '/leaderboard',
    component: LeaderboardPage,
    meta: { title: 'Leaderboard' },
  },
  {
    name: 'manage-issue',
    path: '/manage-issue',
    component: ManageIssuePage,
    meta: {
      requireLogin: true,
      title: 'Issue details',
    },
  },
  {
    name: 'manage-merge-request',
    path: '/manage-merge-request',
    component: ManageMergeRequestPage,
    meta: {
      requireLogin: true,
      title: 'Merge request details',
    },
  },
  {
    name: 'organization',
    path: '/organizations/:organizationName',
    component: OrganizationPage,
    meta: {
      footerNote: ORGANIZATION_FOOTER,
    },
  },
  {
    name: 'organizations',
    path: '/organizations',
    component: OrganizationsPage,
    meta: {
      title: 'Organization leaderboard',
      footerNote: ORGANIZATION_FOOTER,
    },
  },
  {
    name: 'rewards',
    path: '/rewards',
    component: RewardsPage,
    meta: {
      title: 'Rewards',
    },
  },
  {
    name: 'bonus-points',
    path: '/bonus-points',
    component: BonusPointsPage,
    meta: {
      title: 'Bonus Points',
    },
  },
  {
    name: 'top-annual-contributors',
    path: '/top-annual-contributors',
    component: TopAnnualContributorsPage,
    meta: {
      title: 'Top Annual Contributors',
    },
  },
  {
    name: 'user',
    path: '/users/:userHandle',
    component: UserPage,
  },
  {
    name: 'user-edit',
    path: '/users/:userId/edit',
    component: UserEditPage,
    meta: { requireAdmin: true },
  },
  {
    name: 'activity',
    path: '/activity/:platform',
    component: ActivitiesPage,
    meta: {
      title: 'Activity',
    },
  },
  {
    name: 'git-activity-dashboard',
    path: '/dashboard/git',
    component: ActivityDashboardPage,
    props: {
      allSeries: ['git_patch', 'git_review', 'git_commit_merged', 'git_bug', 'git_question', 'git_discussion', 'git_announce'],
      seriesLabels: {
        git_patch: 'Patches',
        git_review: 'Reviews',
        git_commit_merged: 'Merged Commits',
        git_bug: 'Bugs',
        git_question: 'Questions',
        git_discussion: 'Discussions',
        git_announce: 'Announcements',
      },
    },
    meta: {
      title: 'Git Activity Dashboard',
      platform: 'git',
    },
  },
  {
    name: 'issue-finder-dashboard',
    path: '/dashboard/issue-finder',
    component: IssueFinderDashboardPage,
    meta: { title: 'Issue finder dashboard' },
  },
  {
    name: 'activity-dashboard',
    path: '/dashboard/:platform',
    component: ActivityDashboardPage,
    meta: {
      title: 'Activity Dashboard',
    },
  },
  {
    name: 'team-member',
    path: '/team-members/:username',
    component: TeamMemberPage,
    meta: {
      title: 'Team member',
    },
  },
];
